import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './apiErrors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error: unknown) => {
        // A 4xx answer (not found, deleted, forbidden) won't change on retry - show it straight away
        if (error instanceof ApiRequestError && error.status !== undefined && error.status >= 400 && error.status < 500) {
          return false;
        }
        // Don't retry on 401/403 errors
        if (error && typeof error === 'object' && 'response' in error && typeof (error as { response?: { status?: number } }).response?.status === 'number' && ((error as { response: { status: number } }).response.status === 401 || (error as { response: { status: number } }).response.status === 403)) {
          return false;
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      // Never retry mutations (TanStack's default). Hooks throw plain Errors carrying the server's message, so a
      // status-based rule can't tell a 4xx from a 5xx: every failure - including business-rule rejections like
      // "this customer can't be deleted" - was re-sent twice, delaying the error by ~3s, and a retried POST can
      // create duplicates.
      retry: false,
    },
  },
});